export const HEADERS = {
  PdfApiKey: 'x-pdf-api-key',
  PdfCerberAuthorization: 'x-pdf-cerber-authorization',
  IsClientSide: 'x-is-client-side',
} as const satisfies Record<string, `x-${string}`>
